import { MetaConversionsApiClient } from '@fourthwall/services/dist/MetaConversionsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUpdateMetaconversionsMutation = createMutationHook(
  MetaConversionsApiClient.setPixel,
  {
    mutationKey: ['metaConversionUpdate'],
  },
)
